import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VBtn, VCardText, VAlert, VSimpleTable } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosFormDialogDemo',
    setup(__props) {
        const dialogBasic = ref(false);
        const dialogAdvanced = ref(false);
        const isLoading = ref(false);
        const lastSearch = ref('');
        const basicTabs = [
            { name: 'Info', href: '#info', icon: 'mdi-information-outline' },
            { name: 'Config', href: '#settings', icon: 'mdi-cog-outline' }
        ];
        const advancedTabs = [
            { name: 'Usuarios', href: '#users', icon: 'mdi-account-group' },
            { name: 'Roles', href: '#roles', icon: 'mdi-shield-account' }
        ];
        function handleSearch(val) {
            lastSearch.value = val;
        }
        function toggleLoading() {
            isLoading.value = true;
            setTimeout(() => {
                isLoading.value = false;
            }, 2000);
        }
        const propsDocs = [
            { name: 'dialog', type: 'boolean', default: 'false', desc: 'Controla la visibilidad del diálogo.' },
            { name: 'tabs', type: 'TabItem[]', default: '[]', desc: 'Configuración de las pestañas (name, href, icon, etc.).' },
            { name: 'hideTabs', type: 'boolean', default: 'false', desc: 'Oculta la barra de pestañas si es true.' },
            { name: 'loading', type: 'boolean', default: 'false', desc: 'Activa el overlay de carga.' },
            { name: 'widthDialog', type: 'string', default: "'1200px'", desc: 'Ancho del componente v-dialog.' },
            { name: 'showSearch', type: 'boolean', default: 'false', desc: 'Muestra el input de búsqueda en la cabecera.' },
            { name: 'contentClass', type: 'string', default: 'undefined', desc: 'Clase CSS aplicada al contenedor del diálogo (v-dialog content-class).' },
            { name: 'maxHeightContainer', type: 'string', default: 'undefined', desc: 'Altura máxima del contenedor principal (v-card).' },
            { name: 'cardClass', type: 'string', default: "''", desc: 'Clase CSS personalizada para el componente v-card.' },
            { name: 'cardTextClass', type: 'string', default: "''", desc: 'Clase CSS personalizada para el componente v-card-text.' },
        ];
        return { __sfc: true, dialogBasic, dialogAdvanced, isLoading, lastSearch, basicTabs, advancedTabs, handleSearch, toggleLoading, propsDocs, VContainer, VRow, VCol, VBtn, VCardText, VAlert, VSimpleTable, CodePreview, DemoSection };
    }
});
